import React from 'react';
import outdatedDigital from '../assests/outdated_digital.png';
import lackOfTech from '../assests/lack_of_tech.png';
import inefficientProcess from '../assests/inefficient_process.png';
import inconsistentBranding from '../assests/inconsistent_branding.png';
import everChanging from '../assests/ever_changing.png';

const Challenges = () => {
  const challenges = [
    {
      title: 'Outdated Digital Presence',
      description: 'Outdated website or app turns away potential clients.',
      image: outdatedDigital,
    },
    {
      title: 'Lack of Technical Expertise',
      description: 'Struggling with evolving tech and costly in-house teams.',
      image: lackOfTech,
    },
    {
      title: 'Inefficient Processes',
      description: 'Manual work and outdated tools slow teams down.',
      image: inefficientProcess,
    },
    {
      title: 'Inconsistent Branding',
      description: 'Brand looks different across platforms, weakening trust.',
      image: inconsistentBranding,
    },
    {
      title: 'Low Online Visibility',
      description: 'Brand buried in search results with weak presence.',
      image: inconsistentBranding, // Using inconsistent_branding as placeholder since low_online_visibility.png is missing
    },
    {
      title: 'Ever-Changing Demands',
      description: "Business evolves but rigid solutions can't keep pace.",
      image: everChanging,
    },
  ];

  return (
    <section className='bg-neutral-100 py-12 sm:py-16 lg:py-20'>
      <div className='container mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='max-w-[1053px] mx-auto'>
          {/* Heading */}
          <div className='mb-12 sm:mb-16'>
            <h2 className='text-2xl sm:text-3xl lg:text-4xl font-bold text-center text-gray-900 px-4'>
              The Challenges Modern Businesses face and the solutions we provide
              for
            </h2>
          </div>

          {/* Cards Grid */}
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'>
            {challenges.map((challenge, index) => (
              <div
                key={index}
                className='bg-white rounded-[38px] overflow-hidden shadow-md hover:shadow-lg transition-shadow'
                style={{ padding: '6px' }}
              >
                {/* Inner container with rounded corners - 32px */}
                <div className='w-full h-full rounded-[32px] overflow-hidden flex flex-col'>
                  {/* Image - 256px height with rounded top corners */}
                  <div className='h-64 bg-gray-100 overflow-hidden rounded-t-[32px]'>
                    <img
                      src={challenge.image}
                      alt={challenge.title}
                      className='w-full h-full object-cover'
                    />
                  </div>

                  {/* Content */}
                  <div className='p-4 flex flex-col gap-2'>
                    {/* Problem Badge - exact Figma styling */}
                    <div>
                      <span
                        className='inline-block px-3 py-1 text-[10px] font-medium text-[#FB2C36] rounded-full'
                        style={{
                          backgroundColor: 'rgba(255, 226, 226, 0.6)',
                          letterSpacing: '-0.25px',
                        }}
                      >
                        Problem
                      </span>
                    </div>

                    {/* Title - Roboto Medium, 20px, line-height 28px */}
                    <h3
                      className='text-[20px] font-medium text-black mb-0'
                      style={{ lineHeight: '28px' }}
                    >
                      {challenge.title}
                    </h3>

                    {/* Description - Inter Regular, 14px, line-height 20px */}
                    <p className='text-[14px] font-normal text-black leading-[20px]'>
                      {challenge.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Challenges;
